import { Injectable } from '@angular/core';
// import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})

export class UserService {
    // tab_details = new BehaviorSubject<any>({});
    CURRENT_PERM = { id: null, c_in: 0, r_in: 0, u_in: 0, d_in: 0 };
    userLoggedIn: any = new BehaviorSubject<boolean>(false);
    // private _listners = new Subject<any>();
    constructor() {
        let user = this.getUsrDta();
        if(user) this.loggedIn(true);
        else this.loggedIn(false);
    }

    // listen(): Observable<any> {
    //     return this._listners.asObservable();
    // }

    // filter(filterBy: string) {
    //     this._listners.next(filterBy);
    // }
    // loggedIn(val) {
    //     localStorage.setItem('log', val);
    // }

    // public setUsrDta(data): Promise<string> {
    //     this.USER_DETAILS.next(data);
    //     localStorage.setItem('usrDtls', JSON.stringify(data));
    //     return;
    // }

    public getUsrDta() {
        let user = localStorage.getItem('wto_w_user') ? JSON.parse(localStorage.getItem('wto_w_user')) : null;
        return user;
    }

    public loggedIn(val: boolean) {
        this.userLoggedIn.next(val);
        return;
    }

    public setCurrenPerm(item) {
        // console.log({ c_in: item.c_in, r_in: item.r_in, u_in: item.u_in, d_in: item.d_in })
        // this.CURRENT_PERM = { id: item.mnu_itm_id, c_in: item.c_in, r_in: item.r_in, u_in: item.u_in, d_in: item.d_in };
        // localStorage.setItem('currentUrl', JSON.stringify(item));
        return;
    }
    // settab_details(tabinfo){
    //     this.tab_details.next(tabinfo);
    // }
    // gettab_details(){
    //   return this.tab_details.asObservable;
    // }

}
